import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faMagnifyingGlass,
  faCaretUp,
  faCaretDown,
  faGlobe,
  faArrowRightArrowLeft,
  faBookmark,
  faNetworkWired,
  faEnvelope,
  faChartSimple,
  faDatabase,
  faFolderOpen,
  faClockRotateLeft,
  faServer,
  faCalendar,
  faUsers,
  faBolt,
  faArrowRotateLeft,
  faUserGear,
  faClipboardList,
  faMagnifyingGlassChart,
  faFileLines,
  faCircleCheck,
  faCircleXmark,
  faCircleExclamation,
  faCircleInfo,
  faPlus,
  faArrowRight,
  faXmark,
  faEye,
  faEyeSlash,
  faEllipsisVertical,
  faList,
  faAngleDown,
  faArrowRightLong,
  faArrowUpRightFromSquare,
  faCopy,
  faPause,
  faPen,
  faObjectUngroup,
  faTrash,
  faArrowsRotate,
  faFileImport,
  faTriangleExclamation,
  faEraser,
  faCloud,
  faPlay,
  faCheck,
  faHouse,
  faGear,
  faTerminal,
  faArrowRightToBracket,
  faListUl,
  faUserPlus,
  faFilterCircleXmark,
  faDownload,
  faChevronDown,
  faCircleMinus,
  faLock,
  faChartColumn,
  faFingerprint,
} from '@fortawesome/free-solid-svg-icons';
import { faUser, faBell, faCopy as farCopy } from '@fortawesome/free-regular-svg-icons';
import { faWordpressSimple, faPhp } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('vmax-admin-panel');

  constructor() {
    const library = inject(FaIconLibrary);

    library.addIcons(
      faUser,
      faBell,
      faMagnifyingGlass,
      faCaretUp,
      faCaretDown,
      faGlobe,
      faArrowRightArrowLeft,
      faBookmark,
      faNetworkWired,
      faEnvelope,
      faChartSimple,
      faDatabase,
      faFolderOpen,
      faClockRotateLeft,
      faServer,
      faCalendar,
      faUsers,
      faBolt,
      faArrowRotateLeft,
      faUserGear,
      faClipboardList,
      faMagnifyingGlassChart,
      faFileLines,
      faCircleCheck,
      faCircleXmark,
      faCircleExclamation,
      faCircleInfo,
      faPlus,
      faArrowRight,
      faXmark,
      faEye,
      faEyeSlash,
      faEllipsisVertical,
      faList,
      faAngleDown,
      faArrowRightLong,
      faArrowUpRightFromSquare,
      faCopy,
      faPause,
      faPen,
      faWordpressSimple,
      faObjectUngroup,
      faTrash,
      faArrowsRotate,
      faFileImport,
      faTriangleExclamation,
      farCopy,
      faEraser,
      faCloud,
      faPlay,
      faCheck,
      faHouse,
      faGear,
      faTerminal,
      faArrowRightToBracket,
      faPhp,
      faListUl,
      faUserPlus,
      faFilterCircleXmark,
      faDownload,
      faChevronDown,
      faCircleMinus,
      faLock,
      faChartColumn,
      faFingerprint,
    );
  }
}
